module.exports = __webpack_public_path__ + "static/media/utensil-spoon.e0161d23.svg";